import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-100/50">
      <div className="container-site">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            影片分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型找到你想看的影片</p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-500/40 hover:bg-background-200/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-primary-500 text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm text-foreground-600 group-hover:text-foreground-800 font-medium whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}